import { Injectable, inject } from '@angular/core';
import {ToastMessageUtils} from '@app/core/utils/toast-message.utils';
import {EToastMessageOptions, EToastMessageSeverity} from '@app/shared/enums/toast-message.enum';
import {getCustomerProfileFromInstitutionSettingEffect} from '@app/shared/state/header/header.action';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {Store} from '@ngrx/store';
import {TranslateService} from '@ngx-translate/core';
import {MessageService} from 'primeng/api';
import {catchError, map, of, switchMap} from 'rxjs';
import {InstitutionSettingsService} from '../services/institution-settings.service';
import {
  InstitutionSettingsActions,
  updateInstitution,
  updateInstitutionSettingsFailure,
  updateInstitutionSettingsSuccess,
} from './institution-settings.action';

@Injectable()
export class InstitutionSettingsEffect {
  private readonly actions$ = inject(Actions);
  private readonly institutionSettingsService = inject(InstitutionSettingsService);
  private readonly messageService = inject(MessageService);
  private readonly store = inject(Store);
  private readonly translate = inject(TranslateService);

  globalToast = 'global-toast';
  updateInstitutionSettings$ = createEffect(() =>
    this.actions$.pipe(
      ofType(InstitutionSettingsActions.UpdateInstitutionSettings),
      switchMap(action => this.updateInstitutionSettings(action))
    )
  );

  private updateInstitutionSettings(action: ReturnType<typeof updateInstitution>) {
    return this.institutionSettingsService.updateOrganization(action.request, action.id).pipe(
      map(() => {
        const successMessage = this.translate.instant('InstitutionSettings.SaveSuccessMessage');
        this.showSuccessMessage(successMessage);
        this.store.dispatch(getCustomerProfileFromInstitutionSettingEffect());
        return updateInstitutionSettingsSuccess();
      }),
      catchError(error => {
        console.log(error);
        const errorMessage = this.translate.instant('InstitutionSettings.SaveFailureMessage');
        this.showErrorMessage(errorMessage);
        return of(updateInstitutionSettingsFailure());
      })
    );
  }

  private showErrorMessage(errMsg: string): void {
    ToastMessageUtils.showMessage({
      messageService: this.messageService,
      toastKey: this.globalToast,
      severity: EToastMessageSeverity.Error,
      messageDetail: errMsg,
      closable: true,
      life: EToastMessageOptions.LifeTime,
    });
  }

  private showSuccessMessage(msg: string): void {
    ToastMessageUtils.showMessage({
      messageService: this.messageService,
      toastKey: this.globalToast,
      severity: EToastMessageSeverity.Success,
      messageDetail: msg,
      closable: true,
      life: EToastMessageOptions.LifeTime,
    });
  }
}
